var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "input-array",
    },
    [
      _c(
        "span",
        {
          staticClass: "sr-only",
          attrs: {
            "aria-live": "assertive",
          },
        },
        [_vm._v(_vm._s(_vm.assistiveLive))]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "default nohover",
        },
        [
          _c(
            "colgroup",
            [
              _c("col", {
                staticStyle: {
                  width: "16px",
                },
              }),
              _vm._v(" "),
              _c("col"),
              _vm._v(" "),
              _vm._l(_vm.additionalColspan, function (i) {
                return _c("col", {
                  key: "colspan-".concat(i),
                })
              }),
              _vm._v(" "),
              _c("col", {
                staticStyle: {
                  width: "24px",
                },
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("thead", [
            _c(
              "tr",
              [
                _c("th", {
                  staticClass: "dragcolumn",
                }),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.labelPlural))]),
                _vm._v(" "),
                _vm._t("header-cells"),
                _vm._v(" "),
                _c("th", {
                  staticClass: "actions",
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "Draggable",
            {
              staticClass: "statements",
              attrs: {
                handle: ".dragarea",
                tag: "tbody",
              },
              model: {
                value: _vm.options,
                callback: function callback($$v) {
                  _vm.options = $$v
                },
                expression: "options",
              },
            },
            _vm._l(_vm.options, function (option, index) {
              return _c(
                "tr",
                {
                  key: index,
                },
                [
                  _c(
                    "td",
                    {
                      staticClass: "dragcolumn",
                    },
                    [
                      _c(
                        "a",
                        {
                          ref: "draghandle",
                          refInFor: true,
                          staticClass: "dragarea",
                          attrs: {
                            tabindex: "0",
                            title: _vm.$gettextInterpolate(
                              _vm.$gettext(
                                "Sortierelement f\xFCr %{label} %{option}. Dr\xFCcken Sie die Tasten Pfeil-nach-oben oder Pfeil-nach-unten, um dieses Element in der Liste zu verschieben."
                              ),
                              {
                                option: option,
                                label: _vm.label,
                              }
                            ),
                          },
                          on: {
                            keydown: function keydown($event) {
                              return _vm.keyHandler($event, index)
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "drag-handle",
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.options[index],
                          expression: "options[index]",
                        },
                      ],
                      ref: "inputs",
                      refInFor: true,
                      attrs: {
                        type: "text",
                        placeholder: _vm.label,
                      },
                      domProps: {
                        value: _vm.options[index],
                      },
                      on: {
                        paste: function paste(ev) {
                          return _vm.onPaste(ev, index)
                        },
                        input: function input($event) {
                          if ($event.target.composing) {
                            return
                          }

                          _vm.$set(_vm.options, index, $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _vm._t("body-cells"),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "actions",
                    },
                    [
                      _c("StudipIcon", {
                        attrs: {
                          name: "delete",
                          shape: "trash",
                          size: 20,
                          title: _vm.$gettextInterpolate(
                            _vm.$gettext("%{label} löschen"),
                            {
                              label: _vm.label,
                            }
                          ),
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                            return _vm.deleteOption(index)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("tfoot", [
            _c("tr", [
              _c(
                "td",
                {
                  attrs: {
                    colspan: 3 + _vm.additionalColspan,
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "as-link",
                      attrs: {
                        title: _vm.$gettextInterpolate(
                          _vm.$gettext("%{label} hinzufügen"),
                          {
                            label: _vm.label,
                          }
                        ),
                      },
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          return _vm.addOption()
                        },
                      },
                    },
                    [
                      _c("StudipIcon", {
                        attrs: {
                          shape: "add",
                          size: 20,
                          alt: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }